export default __webpack_public_path__ + "static/media/da.6a7a1bc9.svg";